module.exports = __webpack_public_path__ + "img/orange_036.44c09f62.png";